import { LoaderStatus } from "../../utils/constants";
import { Order, RefreshedReserveData } from "./timer.types";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type TimerState = Readonly<{
  deadline: number;
  resendEnable: boolean;
  modalOpen: boolean;
  notificationOpen: boolean;
  referredSFNumber: string;
  referredOrgId: number;
  minimised: boolean;
  reservedData: RefreshedReserveData | null;
  fetchReservedDataStatus: LoaderStatus;
  fetchReservedDataError: Error | null;

  pendingOrder: Order | null;

  cancelOrderStatus: LoaderStatus;
  cancelOrderError: Error | null;

  successOrderId: number;
  successVoipNumber: string;

  order: Order | null;
}>;

export const initialState: TimerState = {
  deadline: 0,
  resendEnable: false,
  modalOpen: false,
  notificationOpen: false,
  referredSFNumber: "",
  referredOrgId: 0,
  minimised: false,

  reservedData: null,
  fetchReservedDataStatus: "idle",
  fetchReservedDataError: null,

  pendingOrder: null,

  cancelOrderStatus: "idle",
  cancelOrderError: null,

  successOrderId: 0,
  successVoipNumber: "",

  order: null,
};

export const timerSlice = createSlice({
  name: "timer",
  initialState,
  reducers: {
    setDeadline: (state, action: PayloadAction<number>) => {
      state.deadline = action.payload;
    },
    setResendEnable: (state, action: PayloadAction<boolean>) => {
      state.resendEnable = action.payload;
    },
    setModalOpen: (state, action: PayloadAction<boolean>) => {
      state.modalOpen = action.payload;
    },
    setNotificationOpen: (state, action: PayloadAction<boolean>) => {
      state.notificationOpen = action.payload;
    },
    setReferredSFNumber: (state, action: PayloadAction<string>) => {
      state.referredSFNumber = action.payload;
    },
    setReferredOrgId: (state, action: PayloadAction<number>) => {
      state.referredOrgId = action.payload;
    },
    setMinimised: (state, action: PayloadAction<boolean>) => {
      state.minimised = action.payload;
    },
    setSuccessOrderId: (state, action: PayloadAction<number>) => {
      state.successOrderId = action.payload;
    },
    setSuccessVoipNumber: (state, action: PayloadAction<string>) => {
      state.referredSFNumber = action.payload;
    },
    setOrder: (state, action: PayloadAction<Order | null>) => {
      state.order = action.payload;
    },
  },
});

export const {
  setDeadline,
  setResendEnable,
  setModalOpen,
  setNotificationOpen,
  setReferredSFNumber,
  setReferredOrgId,
  setSuccessOrderId,
  setSuccessVoipNumber,
  setOrder,
  setMinimised,
} = timerSlice.actions;

export const timerReducer = timerSlice.reducer;
